import {Typography, useTransition} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import {logEvent} from '@logistics-frontend/modules/rum/event'

import {config} from 'src/shared/config'
import {Brand} from 'src/shared/types'

import {YandexPromo, YangoPromo} from '../promo'
import {isCountry} from './ActiveScreen.utils'
import {classes} from './styles'

const CompleteScreen: React.FC = () => {
  const t = useI18n()
  const AppPromo = config.brand === Brand.Yango ? YangoPromo : YandexPromo
  const text = config.brand === Brand.Yango ? t('yango_route_order_complete') : t('route_order_complete')
  const isNotTurkey = !isCountry('tr')

  useTransition(() => Promise.resolve(logEvent('route_order_complete')))

  return (
    <div className={classes.root}>
      <div className={`${classes.item} ${classes.illustration}`}>
        <div className={classes.illustrationImage} />
        <Typography className={classes.illustrationText} thickness="bold" variant="title4">
          {text}
        </Typography>
      </div>
      {isNotTurkey ? (
        <div className={classes.item}>
          <AppPromo fullWidth />
        </div>
      ) : null}
    </div>
  )
}

export default CompleteScreen
